<template>
  <div v-if="response.status === 200" class="dashboard-main-content-wrapper">
    <slot />
  </div>
  <div v-else class="card form-card">
    <div class="card-body form-card-body">
      {{ message }}
    </div>
  </div>
</template>

<script>

const MESSAGES = {
  401: "Unauthorized Request",
  403: "Forbidden",
  404: "Missing document",
  500: "Something went wrong"
};

export default {
  name: "Page",

  props: {
    response: { type: Object, required: true }
  },

  computed: {
    message () {
      return MESSAGES[this.response.status];
    }
  },

  mounted () {
    if (this.response.status === 401) {
      location.reload();
    }
  }
};
</script>
